import { FeedbackLevel } from '@payaca/types/feedbackTypes';
import { FunctionComponent, type JSX } from 'react';

import UntitledIcon, { TIconName } from '@payaca/untitled-icons';
import './FeedbackMessage.sass';

type Props = {
  message: string;
  feedbackLevel?: FeedbackLevel;
  iconBefore?: TIconName;
  className?: string;
};

const FeedbackMessage: FunctionComponent<Props> = ({
  message,
  feedbackLevel,
  iconBefore,
  className,
}: Props): JSX.Element => {
  return (
    <p
      className={`flex space-x-4 feedback-message ${
        className ? className : ''
      } ${feedbackLevel ? `feedback-level-${feedbackLevel}` : ''}`}
    >
      {iconBefore && (
        <span className="icon-container">
          <UntitledIcon name={iconBefore} />
        </span>
      )}
      <span>{message}</span>
    </p>
  );
};

export const ErrorMessage: FunctionComponent<Props> = ({
  message,
  className,
}: Props): JSX.Element => {
  return (
    <FeedbackMessage
      message={message}
      feedbackLevel={FeedbackLevel.ERROR}
      iconBefore="info-circle.3"
      className={className}
    />
  );
};

export const SuccessMessage: FunctionComponent<Props> = ({
  message,
}: Props): JSX.Element => {
  return (
    <FeedbackMessage
      message={message}
      feedbackLevel={FeedbackLevel.SUCCESS}
      iconBefore="check"
    />
  );
};

export default FeedbackMessage;
